import $ from 'jquery';

$.formatDate = (ts, type) => {
  let d = new Date(1000 * ts);

  const td = (str) => $.pad(str, 2, '0');

  switch (type) {
    case 'short':
    case 'date':
      return [td(d.getDate()), td(1 + d.getMonth()), d.getFullYear()].join('.');

    default:
      return (
        [td(d.getDate()), td(1 + d.getMonth()), d.getFullYear()].join('.') +
        ' ' +
        [td(d.getHours()), td(d.getMinutes())].join(':')
      );
  }
};
